import { useEffect, useState } from "react";
import { navItems, siteMeta } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      {/* 顶部更新条（压顶） */}
      <div className="bg-accent-600 text-background-50">
        <div className="px-4 md:px-6 h-9 flex items-center justify-between gap-4 text-xs md:text-[13px]">
          <div className="flex items-center gap-2 min-w-0">
            <span className="flex items-center gap-1.5 shrink-0">
              <span className="relative flex w-2 h-2" aria-hidden="true">
                <span className="absolute inline-flex w-full h-full rounded-full bg-background-50/70 animate-ping" />
                <span className="relative inline-flex w-2 h-2 rounded-full bg-background-50" />
              </span>
              <span className="font-medium whitespace-nowrap">{siteMeta.statusText}</span>
            </span>
            <span className="hidden sm:inline text-background-50/70 truncate">
              {siteMeta.statusDetail}
            </span>
          </div>
          <span className="hidden md:inline-flex items-center gap-1.5 text-background-50/85 whitespace-nowrap">
            <i className="ri-history-line" aria-hidden="true" />
            最近更新：{siteMeta.updatedAt}
          </span>
        </div>
      </div>

      {/* 主导航 */}
      <nav
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-background-200"
            : "bg-background-50/70 backdrop-blur-sm border-transparent"
        }`}
        aria-label="页面导航"
      >
        <div className="px-4 md:px-6 h-14 md:h-16 flex items-center gap-4">
          <a
            href="#top"
            className="flex items-center gap-2 shrink-0 cursor-pointer"
            aria-label={`${siteMeta.name} 回到顶部`}
          >
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-tv-line text-lg" aria-hidden="true" />
            </span>
            <span className="font-heading font-bold text-lg text-foreground-950 tracking-wide">
              {siteMeta.name}
            </span>
          </a>

          <ul className="hidden lg:flex items-center gap-1 mx-auto">
            {navItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-100/60 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2 ml-auto lg:ml-0">
            <a
              href="#latest-address"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-link" aria-hidden="true" />
              立即访问
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="展开导航菜单"
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
            <ul className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={() => setMenuOpen(false)}
                    className="block px-3 py-2 rounded-md text-sm text-foreground-800 bg-background-100 hover:bg-primary-100/70 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </nav>
    </header>
  );
}